import styled from 'styled-components';
import { normalizeHeight } from '../../utils/normalize';

export const MasterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ImageBackground = styled.div`
  position: absolute;
  z-index: -1;
  object-fit: cover;
  max-height: 350px;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  gap: 60px;
  width: fit-content;
  scroll: none;
  margin-top: ${normalizeHeight(66)};
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 60px;
  margin-top: 174px;
  gap: 10px;
`;

export const Posts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 284px;
`;